import { useState } from 'react';

export const useCopyButton = () => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = (value: string) => {
    navigator.clipboard.writeText(value);
    setCopied(true);
  };

  const handleMouseLeave = () => {
    setCopied(false);
  };

  return { copied, handleCopy, handleMouseLeave };
};
